import { COMPONENT_LAYOUT_LIST } from 'global/constants';
import {
  ComponentLinkItemPreview,
  ComponentLinkItemPreviewNarrow,
} from '../shared/component-parts';
import { ViewProps } from './link.constants';

const LinkStaticPreview = (props: ViewProps) => {
  if (!props.stimulusResourceProperties?.link) return null;

  const componentLinkItemProps = {
    primaryText: props.stimulusResourceProperties.resourceName,
    squareImage: props.stimulusResourceProperties.coverImage,
  };

  return (
    <>
      {props.properties.layout?.display === COMPONENT_LAYOUT_LIST ? (
        <ComponentLinkItemPreviewNarrow {...componentLinkItemProps} />
      ) : (
        <ComponentLinkItemPreview {...componentLinkItemProps} />
      )}
    </>
  );
};

export default LinkStaticPreview;
